// ── services/api/index.ts — barrel export ─────────────────────────────────────
export { api, ApiException } from './client';
export type { ApiError } from './client';

export { authApi } from './auth.api';
export type { AuthResponse, LoginPayload, SignupPayload } from './auth.api';

export { treesApi } from './trees.api';
export type { TreeListItem, TreeDetail, AddNodePayload, AddRelationshipPayload, InviteStatus, NodeInviteStatus } from './trees.api';

export { pincodeApi } from './pincode.api';
export type { VillageCandidate } from './pincode.api';

export { conversationsApi } from './conversations.api';
export type {
  Conversation,
  Message,
  ConversationParticipant,
  MessagePreview,
  PaginatedResponse,
} from './conversations.api';

export { invitesApi } from './invites.api';
export type { GeneratedInvite, InviteInfo, ClaimResult } from './invites.api';

export { innerCircleApi } from './innerCircle.api';
export type {
  ModuleType,
  PendingConsent,
  MatrimonyProfile,
  MatrimonyCandidate,
  JobListing,
  JobSeeker,
  ServiceListing,
  MyJobListing,
  MyServiceListing,
  VouchSummary,
  Vouch,
  MatrimonyProfileView,
  JobListingView,
  JobSeekerView,
  ServiceListingView,
} from './innerCircle.api';
